export const PRO2_FIRMWARE_FILE_ACCEPT = '.bin,.okpkg,.pp';
